import * as actions from './inf-change-depot.actions';

import { Actions, createEffect, ofType } from '@ngrx/effects';
import { Injectable, inject } from '@angular/core';
import { Observable, from } from 'rxjs';
import { SpxToasterAutoCloseSpeedEnum, spxToasterActions } from '@softpak/components/spx-toaster';
import { catchError, mergeMap } from 'rxjs/operators';

import { ApiInfMethod } from 'src/app/api/api-methods.inf';
import { InfChangeDepotI } from 'src/app/api/inf-change-depot/inf-change-depot.result.int';
import { SharedGenericService } from 'src/app/shared/services/shared-generic.service';
import { loadingInfChangeDepot } from 'src/app/shared/_config/i18n/i18n-interface';
import { spxSpinnerActions } from '@softpak/components/spx-spinner';

@Injectable()
export class InfChangeDepotEffects {
    private readonly actions$ = inject(Actions);
    private readonly sharedGenericService = inject(SharedGenericService);

    load$: Observable<any> = createEffect(() => this.actions$.pipe(
        ofType(actions.load),
        mergeMap(action => from(this.sharedGenericService.invoke(ApiInfMethod.infChangeDepot, action.query))
            .pipe(
                mergeMap((_result: InfChangeDepotI) => {
                    const container = action.query.containerNumber;
                    const depot = action.query.depotName;
                    return [
                        actions.received({ result: {} }),
                        spxToasterActions.createSuccess({
                            messageText: `${container} has been moved to depot ${depot}`,
                            autoClose: SpxToasterAutoCloseSpeedEnum.DEFAULT,
                        }),
                    ];
                }),
                catchError((error) => {
                    console.error(error);
                    return [
                        actions.error({
                            error,
                        }),
                        spxToasterActions.createError({
                            autoClose: error.autoclose ? 5000 : undefined,
                            messageText: `${error?.title ? `${error?.title}: ` : ``} ${error.message}`,
                        }),
                    ];
                })
            )))
    );

    afterLoad$: Observable<any> = createEffect(() => this.actions$.pipe(
        ofType(actions.load),
        mergeMap(() => [
            spxSpinnerActions.show({
                action: loadingInfChangeDepot
            }),
        ]))
    );

    afterError$: Observable<any> = createEffect(() => this.actions$.pipe(
        ofType(actions.error),
        mergeMap(() => [
            spxSpinnerActions.hide({
                action: loadingInfChangeDepot
            }),
        ]))
    );

    afterReceived$: Observable<any> = createEffect(() => this.actions$.pipe(
        ofType(actions.received),
        mergeMap(() => [
            spxSpinnerActions.hide({
                action: loadingInfChangeDepot
            }),
        ]))
    );

}
